import styled from 'styled-components';

import { basicBodyTextStyle, Link } from '@dreryk/react-components';

export const StyledLink = styled(Link)`
   gap: 4px;
   ${basicBodyTextStyle};
`;

StyledLink.displayName = 'StyledLink';
